<template>
  <div>
    <div
      v-if="fuelTank"
      @click="!subscribingWifiProduct ? detailsOrEnrollment() : ''"
      data-test-hook="tank-utility-apparatus-card"
      class="card"
      :class="getClass()"
    >
      <!--Header-->
      <div
        v-if="tankHasAllProperties() && isSubscriptionGracePeriod()"
        class="card-header dashboard-card-header bg-statusWarning"
      >
        <div data-test-hook="tank-utility-apparatus-card-header" class="row w-100 no-gutters align-items-center">
          <div class="float-left col">
            <p data-test-hook="tank-utility-apparatus-card-header-text" class="py-0 my-0">
              <strong data-test-hook="HeaderText" class="py-0 my-0">
                {{ $t('xUpdateYourPaymentMethod') }}
              </strong>
            </p>
          </div>
          <div class="float-right mr-0 pr-0 col-auto">
            <i class="fas fa-arrow-right" />
          </div>
        </div>
      </div>
      <div v-else-if="tankDealerSubscriptionExpired()">
        <div class="card-header dashboard-card-header bg-statusWarning">
          <div data-test-hook="DealerHeader" class="row w-100 no-gutters">
            <div class="float-left col">
              <strong data-test-hook="HeaderText" class="py-0 my-0">
                {{ $t('xYourDealerManagedSubscriptionHasExpired') }}
              </strong>
            </div>
            <div class="float-right mr-0 pr-0 col-auto">
              <i class="fa-solid fa-arrow-right" />
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="tankHasSubscription() && !tankHasAllProperties()" class="card-header dashboard-card-header">
        <div data-test-hook="tank-utility-apparatus-card-header" class="row w-100 no-gutters align-items-center">
          <div class="float-left col">
            <p class="py-0 my-0">
              <strong>{{ $t('xWaitingForData') }}</strong>
            </p>
          </div>
        </div>
      </div>
      <div v-else-if="tankHasDealerAndActivePremiumSub()" class="card-header dashboard-card-header bg-statusWarning">
        <div data-test-hook="tank-utility-apparatus-card-header" class="row w-100 no-gutters align-items-center">
          <div class="float-left col">
            <p data-test-hook="tank-utility-apparatus-card-header-text" class="py-0 my-0">
              <strong>{{ $t('xYourAccountNeedsAttentionHeader') }}</strong>
            </p>
          </div>
          <div class="float-right mr-0 pr-0 col-auto">
            <i class="fas fa-arrow-right" />
          </div>
        </div>
      </div>
      <div v-else-if="!tankHasSubscription()" class="card-header dashboard-card-header bg-statusWarning">
        <div data-test-hook="tank-utility-apparatus-card-header" class="row w-100 no-gutters align-items-center">
          <div class="float-left col">
            <p data-test-hook="tank-utility-apparatus-card-header-text" class="py-0 my-0">
              <strong v-if="tankHadPreviousSubscription()">{{ $t('xYourAccountNeedsAttentionHeader') }}</strong>
              <strong v-else>{{ $t('xFinishSetup') }}</strong>
            </p>
          </div>
          <div class="float-right mr-0 pr-0 col-auto">
            <i class="fas fa-arrow-right" />
          </div>
        </div>
      </div>
      <div v-else-if="!isConnected" class="card-header dashboard-card-header bg-statusDisconnected">
        <div data-test-hook="tank-utility-apparatus-card-header" class="row w-100 no-gutters align-items-center">
          <div class="float-left col">
            <p data-test-hook="tank-utility-apparatus-card-header-text" class="py-0 my-0">
              <strong>{{ noSignalMessage() }}</strong>
            </p>
          </div>
          <div class="float-right mr-0 pr-0 col-auto">
            <i class="fas fa-arrow-right" />
          </div>
        </div>
      </div>
      <div v-else class="card-header dashboard-card-header">
        <div data-test-hook="tank-utility-apparatus-card-header" class="row w-100 no-gutters align-items-center">
          <div
            v-if="fuelLevel"
            class="float-left col-auto"
            data-test-hook="tank-utility-apparatus-card-header-fuel-level"
          >
            <i class="far fa-gauge-max" data-test-hook="tank-utility-apparatus-card-header-fuel-level-icon" />
            {{ fuelLevel }}%
          </div>
          <div v-if="fuelType" class="float-left ml-3 col-auto">
            <i data-test-hook="tank-utility-apparatus-card-header-fuel-type-icon" class="far fa-flame mr-1" />
            <span data-test-hook="tank-utility-apparatus-card-header-fuel-type" style="text-transform: capitalize">{{
              fuelType
            }}</span>
          </div>
          <div class="text-right float-right mr-0 pr-0 col">
            <button
              class="btn card-header-button btn-warning"
              style="margin: -0.75em -0.5em"
              @click="detailsOrEnrollment()"
            >
              <i class="fas fa-arrow-right"></i>
            </button>
          </div>
        </div>
      </div>
      <!--Card Body-->
      <div class="card-body">
        <div class="overlay"></div>
        <div class="row d-flex">
          <div class="col">
            <h4 class="mb-0 py-2">
              <i
                data-test-hook="tank-utility-apparatus-card-disconnected-icon"
                class="fa-fw mr-1 fas"
                :class="noSignalIcon()"
              ></i>
              {{ getStatusText() }}
            </h4>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-4">
            <img
              v-if="orientation == 'horizontal'"
              :src="require('@/assets/images/tank-image.jpg')"
              :alt="$t('xHeroImage')"
              class="tankImage img-fluid"
              data-test-hook="tank-utility-apparatus-card-hero-image"
            />
            <img
              v-else
              :src="require('@/assets/images/vertical-propane-tank.jpg')"
              :alt="$t('xHeroImage')"
              class="tankImage img-fluid"
              data-test-hook="tank-utility-apparatus-card-hero-image"
            />
          </div>
          <div class="col-8">
            <div class="row mt-2">
              <div data-test-hook="tank-utility-apparatus-card-address" class="ellipsis-overflow col">
                {{ fuelTank.localizedAddress }}
              </div>
            </div>
            <div class="row mt-2">
              <div class="col">
                <h2 data-test-hook="tank-utility-apparatus-tank-name" class="pb-1 mb-0">{{ fuelTank.name }}</h2>
              </div>
            </div>
            <div v-if="fuelTank.isDealerManaged && fuelTank.preferredDealerName" class="row mt-2">
              <div data-test-hook="tank-utility-apparatus-card-dealer" class="ellipsis-overflow col">
                <i class="fa-light fa-user-helmet-safety" data-test-hook="tank-utility-apparatus-card-dealer-icon" />
                {{ $t('xDealerManaged') | formatLabel }}
                {{ fuelTank.preferredDealerName }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--Footer-->
      <div class="card-footer apparatus-card-footer">
        <div class="row">
          <div class="col-4">
            <div v-if="capacity || (!tankHasAllProperties() && tankHasSubscription())" class="row">
              <div data-test-hook="tank-utility-apparatus-card-fuel-capacity-label" class="text-small col">
                {{ $t('xFuelCapacity') }} ({{ this.abbreviatedLiquidUom }})
              </div>
            </div>
            <div v-if="capacity || (!tankHasAllProperties() && tankHasSubscription())" class="row">
              <div class="col">
                <strong data-test-hook="tank-utility-apparatus-card-fuel-capacity">{{
                  capacity ? this.convertGallonsToPreferredUnit(capacity) : 'N/A'
                }}</strong>
              </div>
            </div>
          </div>
          <div class="col-8">
            <div v-if="lastReadingDate || (!tankHasAllProperties() && tankHasSubscription())" class="row">
              <div data-test-hook="tank-utility-apparatus-card-last-reading-date" class="col">
                {{ 'xLastReadingDate' | formatLabel }}
                {{ displayShortDateTimeWithTZ(lastReadingDate) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--Dealer Managed Subscription Modal-->
    <div
      v-if="fuelTank && fuelTank.apparatusId"
      :id="'dealer-managed-sub-expired' + fuelTank.apparatusId"
      role="dialog"
      class="modal fade show"
    >
      <div class="modal-dialog modal-dialog-centered">
        <span tabindex="0"></span>
        <div tabindex="-1" class="modal-content">
          <header class="modal-header">
            <div class="row w-100 no-gutters align-items-center">
              <div class="col">
                <h2 class="modal-title">
                  <i class="far fa-exclamation-triangle colorOrange mr-1" />
                  {{ $t('xYourAccountNeedsAttentionHeader') }}
                </h2>
              </div>
              <div class="float-right col-auto">
                <button type="button" class="btn btn-icon-button--gray btn-icon-button" @click="closeDealerModal()">
                  <i class="fas fa-times" />
                </button>
              </div>
            </div>
          </header>
          <div class="modal-body">
            <div class="row">
              <div class="col">
                {{ $t('xYourDealerManagedSubscriptionHasExpiredContactDealer') }}
              </div>
            </div>
            <div class="row pt-3">
              <div class="col">
                <strong>
                  {{ $t('xDealerInformation') }}
                </strong>
              </div>
            </div>
            <div class="col pt-1">
              <div class="row pb-1">
                {{ $t(fuelTank.preferredDealerName) }}
              </div>
              <div class="row">
                {{ $t(fuelTank.preferredDealerPhone) }}
              </div>
              <div class="row">
                {{ $t(fuelTank.preferredDealerEmail) }}
              </div>
            </div>
          </div>
          <ModalFooter>
            <button type="button" @click="navToSupportPage()" class="btn btn-primary">
              {{ $t('xContactSupportUpgrade') }}
            </button>
          </ModalFooter>
        </div>
      </div>
    </div>
    <!--Modal-->
    <div style="position: absolute; top: 1040">
      <div
        v-if="fuelTank"
        :id="'free-enrollment-success' + fuelTank.apparatusId"
        role="dialog"
        class="modal"
        aria-modal="true"
      >
        <div class="modal-dialog modal-lg modal-dialog centered" style="top: 25%">
          <span tabindex="0"></span>
          <div tabindex="-1" class="modal-content">
            <header class="modal-header">
              <div class="row w-100 no-gutters align-items-center">
                <div class="col">
                  <h2 class="headerInline mb-0 pb-0">
                    <i class="colorOrange fas fa-plus"></i>
                    {{ $t('xAddATank') }}
                  </h2>
                </div>
              </div>
            </header>
            <div class="modal-body">
              <div class="row no-gutters">
                <div class="col">
                  <lottie
                    :options="successAnimationOptions"
                    v-on:animCreated="handleAnimation"
                    :height="200"
                    :width="200"
                  />
                </div>
              </div>
              <div class="row text-center mt-2">
                <div class="col">
                  <h2 class="colorOrange">
                    <strong>{{ $t('xSuccess') }}!</strong>
                  </h2>
                </div>
              </div>
              <div class="row text-center mt-2">
                <div class="asterisk-text col">{{ $t('xSuccessfullyAddedTank') }}</div>
              </div>
            </div>
            <footer class="modal-footer">
              <button
                data-test-hook="free-enrollment-success-modal-sounds-good-button"
                @click="closeModal()"
                type="button"
                class="btn btn-warning btn-block"
              >
                {{ $t('xSoundsGood') }}
              </button>
            </footer>
          </div>
          <span></span>
        </div>
      </div>
    </div>

    <!-- Manage Credit Card Modal -->
    <ManageGracePeriodModals
      v-if="isSubscriptionGracePeriod()"
      :isWebSubscription="subscriptionStoreIsWebOrLegacy"
      :organizationSubscriptionDetails="organizationSubscriptionDetails"
      :apparatusId="apparatusInfo.apparatusId"
      :accountProfile="accountProfile"
      :apparatusType="apparatusInfo.type"
      :subscriptionStatus="
        this.subscription && this.subscription[0] && this.subscription[0].value && this.subscription[0].value.status
          ? this.subscription[0].value.status
          : null
      "
      :paymentInfo="paymentInfo"
    />

    <!-- Upgrade to premium/re-subscribe modal. -->
    <div
      v-if="fuelTank && fuelTank.apparatusId"
      :id="'upgrade-to-premium-sub-expired' + fuelTank.apparatusId"
      role="dialog"
      class="modal fade show"
    >
      <div class="modal-dialog modal-dialog-centered modal-md" style="width: 600px">
        <span tabindex="0"></span>
        <div tabindex="-1" class="modal-content">
          <header class="modal-header">
            <div class="row w-100 no-gutters align-items-center">
              <div class="col">
                <h2 class="modal-title">
                  <i class="far fa-exclamation-triangle colorOrange mr-1" />
                  {{ $t('xYourAccountNeedsAttentionHeader') }}
                </h2>
              </div>
              <div class="float-right col-auto">
                <button
                  type="button"
                  class="btn btn-icon-button--gray btn-icon-button"
                  @click="closeUpgradeToPremiumModal()"
                >
                  <i class="fas fa-times" />
                </button>
              </div>
            </div>
          </header>
          <div class="modal-body">
            <div class="row">
              <div class="col" v-if="fuelTank.isDealerManaged">
                {{ $t('xRemoteMonitoringExpiredBodyDealerManaged') }}
              </div>
              <div
                class="col"
                v-else-if="doesRequireUpgrade(organizationSubscriptionDetails?.subscriptions, apparatusesToUpgrade)"
              >
                {{ $t('xRemoteMonitoringExpiredBody') }}
              </div>
              <div class="col" v-else>
                {{ $t('xRemoteMonitoringExpiredBodyUpdate') }}
              </div>
            </div>
          </div>
          <ModalFooter>
            <div v-if="fuelTank.isDealerManaged" class="row d-flex pm-1">
              <button type="button" @click="navToSupportPage()" class="mr-3 btn btn-primary">
                {{ $t('xContactSupportUpgrade') }}
              </button>
            </div>
            <div v-else class="row flex-grow-1">
              <button
                type="button"
                class="btn btn-secondary flex-grow-1 mr-3"
                @click="closeUpgradeToPremiumModal(), $refs.removeApparatusModal.checkApparatusSubscription()"
                :disabled="billingMaintenanceFeatureFlagEnabled(currentAppConfig)"
              >
                {{ $t('xRemoveFromAccount') }}
              </button>
              <button
                v-if="!fuelTank.isDealerManaged"
                type="button"
                @click="checkSubscriptionBeforeOpeningUpgradeOrUpdateSubscriptionModal()"
                class="btn btn-primary flex-grow-1"
                :disabled="billingMaintenanceFeatureFlagEnabled(currentAppConfig)"
              >
                <div v-if="doesRequireUpgrade(organizationSubscriptionDetails?.subscriptions, apparatusesToUpgrade)">
                  {{ $t('xUpgradeNow') }}
                </div>
                <div v-else>{{ $t('xUpdateNow') }}</div>
              </button>
            </div>
          </ModalFooter>
        </div>
      </div>
    </div>

    <RemoveApparatus ref="removeApparatusModal" v-if="fuelTank" :apparatus="fuelTank" :showButton="false" />

    <MultipleChargesModal
      v-if="fuelTank && fmSubscriptionDetails"
      :apparatus="fuelTank"
      :currentPremiumSubscription="fmSubscriptionDetails"
    />

    <MobileSubscriptionModal
      v-if="fuelTank"
      :modalId="`mobile-sub-modal-${fuelTank.apparatusId}`"
      :store="mobileSubscriptionStore"
      :apparatusType="fuelTank.type"
      :requireUpgrade="doesRequireUpgrade(organizationSubscriptionDetails?.subscriptions, apparatusesToUpgrade)"
      @removePressed="$refs.removeApparatusModal.checkApparatusSubscription()"
    />

    <ProductsOverLimitModal
      v-if="fuelTank"
      :modalId="`products-over-limit-modal-${fuelTank.apparatusId}`"
      :apparatusType="fuelTank.type"
      @goToRemoveFlow="$refs.removeApparatusModal.checkApparatusSubscription()"
    />

    <UpgradeOrUpdateSubscriptionsModal
      v-if="fuelTank && !tankHasSubscription()"
      :modalId="`upgrade-subscription-modal-${fuelTank.apparatusId}`"
      :apparatus-id="fuelTank.apparatusId"
      :apparatus-list="apparatusesToUpgrade"
      :accountProfile="accountProfile"
    />

    <PendingPlanChangeModal
      v-if="fuelTank"
      :modalId="`pending-plan-change-modal-${fuelTank.apparatusId}`"
      @onYesContinueClick="openUpgradeOrUpdateSubscriptionModal"
    />
    <PendingPlanCancelModal
      v-if="fuelTank"
      :modalId="`pending-plan-cancel-modal-${fuelTank.apparatusId}`"
      :planCanceledDate="pendingCancelRenewalDate"
    />
    <FuelMonitorInvalidRegionModal
      v-if="fuelTank"
      :modalId="`remove-fuel-monitor-invalid-region-${fuelTank.apparatusId}`"
      @onClose="$bvModal.hide(`remove-fuel-monitor-invalid-region-${fuelTank.apparatusId}`)"
    >
      <b-row class="w-100 justify-content-between">
        <button type="button" @click="navToSupportPage()" class="btn btn-primary flex-grow-1 mr-2">
          {{ $t('xContactSupport') }}
        </button>
        <button
          type="button"
          class="btn btn-secondary flex-grow-1"
          @click="
            $bvModal.hide(`remove-fuel-monitor-invalid-region-${fuelTank.apparatusId}`),
              $refs.removeApparatusModal.checkApparatusSubscription()
          "
          :disabled="billingMaintenanceFeatureFlagEnabled(currentAppConfig)"
        >
          {{ $t('xRemoveFromAccount') }}
        </button>
      </b-row>
    </FuelMonitorInvalidRegionModal>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import * as Constants from '@/constants'
import unitMixin from '@/utils/unitMixin'
import Lottie from '../lottie.vue'
import * as successAnimation from '@/assets/images/manage-subscription-success.json'
import {
  getSubscriptionForApparatus,
  getLegacySubscriptionForApparatus,
  subscriptionDetailActive,
  doesRequireUpgrade
} from '@/utils/mixins'
import RemoveApparatus from '@/components/ApparatusDetails/RemoveApparatus'
import MultipleChargesModal from './MultipleChargesModal.vue'
import { isFuelMonitorV2 } from '@/utils/apparatus'
import MobileSubscriptionModal from '../Enrollment/Subscription/MobileSubscriptionModal.vue'
import UpgradeOrUpdateSubscriptionsModal from '../Common/Subscriptions/UpgradeOrUpdateSubscriptionsModal.vue'
import ManageGracePeriodModals from './ManageGracePeriodModals.vue'
import PendingPlanChangeModal from '../Common/Subscriptions/PendingPlanChangeModal.vue'
import PendingPlanCancelModal from '../Common/Subscriptions/PendingPlanCancelModal.vue'
import ProductsOverLimitModal from '../Common/Subscriptions/ProductsOverLimitModal.vue'
import FuelMonitorInvalidRegionModal from '../Enrollment/FuelMonitorInvalidRegionModal.vue'

/** Dashboard card for Fuel Monitors. */
export default {
  props: ['apparatuses', 'apparatusInfo', 'organizationSubscriptionDetailsData', 'paymentInfo', 'apparatusesToUpgrade'],
  components: {
    Lottie,
    RemoveApparatus,
    ManageGracePeriodModals,
    MultipleChargesModal,
    MobileSubscriptionModal,
    UpgradeOrUpdateSubscriptionsModal,
    PendingPlanChangeModal,
    PendingPlanCancelModal,
    ProductsOverLimitModal,
    FuelMonitorInvalidRegionModal
  },
  mixins: [unitMixin],
  data() {
    return {
      batteryLevel: null,
      capacity: null,
      consumptionTypes: null,
      device: null,
      deviceType: null,
      fuelDealerId: null,
      fuelLevel: null,
      fuelTank: null,
      fuelType: null,
      isConnected: false,
      lastReadingDate: null,
      orientation: null,
      subscription: null,
      subscribingWifiProduct: false,
      successAnimationOptions: { animationData: successAnimation, loop: false },
      organizationSubscriptionDetails: null,
      fmSubscriptionDetails: null,
      fmLegacySubscriptionDetails: null,
      mobileSubscriptionStore: null,
      activeMobileSubscription: null,
      subscriptionStoreIsWebOrLegacy: false,
      pendingCancelRenewalDate: null
    }
  },
  computed: {
    ...mapState({
      accountProfile: state => state.account.accountProfile,
      isImpersonating: state => state.auth.isImpersonating,
      currentAppConfig: state => state.application.currentAppConfig
    }),
    apparatusesOverLimit() {
      let hsbCount = 0
      let fmCount = 0
      this.apparatuses?.forEach(apparatus => {
        if (!apparatus.isDealerManaged) {
          if (apparatus.type === Constants.HsbApparatusType) hsbCount++
          else if (apparatus.type === Constants.FuelTankApparatusType) fmCount++
        }
      })

      return hsbCount > Constants.HSB_MAX_AMOUNT || fmCount > Constants.FUEL_MONITOR_MAX_AMOUNT
    },
    isAccountAddressAmericaOrCanada() {
      if (this.accountProfile) {
        return Constants.CountriesGetPaidSubs.includes(this.accountProfile?.address?.country)
      }

      return true
    }
  },
  watch: {
    organizationSubscriptionDetailsData: function(newVal, oldVal) {
      if (newVal) {
        this.organizationSubscriptionDetails = newVal
        this.setSubscriptionDetails()
      }
    }
  },
  methods: {
    doesRequireUpgrade,
    handleAnimation(anim) {
      this.anim = anim
    },
    batteryLevelClass() {
      if (this.batteryLevel) {
        if (this.batteryLevel == 'good') return 'batteryGood'
        else if (this.batteryLevel == 'warning') return 'batteryWarning'
        else return 'batteryCritical'
      }
    },
    closeModal() {
      document.getElementById('free-enrollment-success' + this.fuelTank.apparatusId).style.display = 'none'
    },
    batteryIconClass() {
      if (this.batteryLevel) {
        if (this.batteryLevel == 'good') return 'far fa-battery-full'
        else if (this.batteryLevel == 'warning') return 'far fa-battery-half'
        else return 'far fa-battery-slash'
      }
    },
    detailsOrEnrollment() {
      // if there are any properties missing, we need to finish enrolling
      if (!this.tankHasAllProperties()) {
        this.openEnrollmentFlow()
      }
      // Check if in grace period first before checking dunning/expired because we have a specific modal for this case.
      else if (this.isSubscriptionGracePeriod()) {
        if (!this.billingMaintenanceFeatureFlagEnabled(this.currentAppConfig)) {
          this.$bvModal.show('ManageCreditCardModal' + this.fuelTank.apparatusId)
        }
      } else if (
        this.fuelTank.isDealerManaged &&
        (!this.enrollmentComplete() || this.tankDealerSubscriptionExpired())
      ) {
        document.getElementById('dealer-managed-sub-expired' + this.fuelTank.apparatusId).style.display = 'block'
        this.$appInsights.trackEvent({
          name: 'expired-dealer-managed-sub-tank',
          properties: {
            page: 'dashboard',
            apparatusId: this.fuelTank.apparatusId
          }
        })
      } else if (this.tankHasDealerAndActivePremiumSub()) {
        this.fmSubscriptionDetails = this.organizationSubscriptionDetails?.subscriptions?.find(
          subscription => subscription.store !== Constants.DealerSubscriptionStore
        )
        switch (this.fmSubscriptionDetails?.store) {
          case Constants.AppleSubscriptionStore:
            if (this.isSingleApparatusSubscription(this.fmSubscriptionDetails?.product?.productId)) {
              this.openApparatusWithMultipleSubscriptionsMobilePlatformModal()
            } else if (this.isHomePremiumSubscription(this.fmSubscriptionDetails?.product?.productId)) {
              this.openRemoveApparatusWithMultipleSubscriptionsMobilePlatformModal()
            }
            break
          case Constants.GoogleSubscriptionStore:
            if (this.isSingleApparatusSubscription(this.fmSubscriptionDetails?.product?.productId)) {
              this.openApparatusWithMultipleSubscriptionsMobilePlatformModal()
            } else if (this.isHomePremiumSubscription(this.fmSubscriptionDetails?.product?.productId)) {
              this.openRemoveApparatusWithMultipleSubscriptionsMobilePlatformModal()
            }
            break
          case Constants.WebSubscriptionStore:
            if (this.isSingleApparatusSubscription(this.fmSubscriptionDetails?.product?.productId)) {
              this.openApparatusWithMultipleSubscriptionsModal()
            } else if (this.isHomePremiumSubscription(this.fmSubscriptionDetails?.product?.productId)) {
              this.openHomePremiumApparatusWithMultipleSubscriptionsModal()
            }
            break
          default:
            break
        }
        return
      } else if (
        this.accountHasActiveMobileSubscription() &&
        !subscriptionDetailActive(this.fmSubscriptionDetails?.status)
      ) {
        this.$bvModal.show(`mobile-sub-modal-${this.fuelTank.apparatusId}`) // if there's an active mobile subscription but this tank is NOT part of it (ie manage account banner shown)
      } else if (this.enrollmentComplete()) {
        this.$appInsights.trackEvent({
          name: 'click-apparatus-card',
          properties: { apparatusId: this.fuelTank.apparatusId }
        })
        this.$router.push({
          path: `/details/${this.fuelTank.apparatusId}/deviceDetails`
        })
      } else if (!this.tankHasSubscription()) {
        // ML-2283 - Tanks are not allowed on accounts outside US or CA (existing subs are grandfathered in, or else this would be at the top)
        if (!this.isAccountAddressAmericaOrCanada) {
          this.$bvModal.show(`remove-fuel-monitor-invalid-region-${this.fuelTank.apparatusId}`)
        } else if (this.apparatusesOverLimit) {
          this.$bvModal.show(`products-over-limit-modal-${this.fuelTank.apparatusId}`)
        } else {
          document.getElementById('upgrade-to-premium-sub-expired' + this.fuelTank.apparatusId).style.display = 'block'
        }
      } else {
        // if there are still issues after all these checks, fall back on finishing enrollment
        this.openEnrollmentFlow()
      }
    },
    openUpgradeOrUpdateSubscriptionModal() {
      this.$bvModal.show(`upgrade-subscription-modal-${this.fuelTank.apparatusId}`)
    },
    checkSubscriptionBeforeOpeningUpgradeOrUpdateSubscriptionModal() {
      this.closeUpgradeToPremiumModal()
      if (this.hasPendingProductChange()) {
        this.openPlanPendingChangeModal()
      } else if (this.hasPendingCancelPlan()) {
        this.openPlanPendingCancelModal()
      } else {
        this.openUpgradeOrUpdateSubscriptionModal()
      }
    },
    openApparatusWithMultipleSubscriptionsModal() {
      document.getElementById('apparatus-with-multiple-subscriptions' + this.fuelTank.apparatusId).style.display =
        'block'
    },
    openHomePremiumApparatusWithMultipleSubscriptionsModal() {
      document.getElementById(
        'home-premium-apparatus-with-multiple-subscriptions' + this.fuelTank.apparatusId
      ).style.display = 'block'
    },
    openApparatusWithMultipleSubscriptionsMobilePlatformModal() {
      document.getElementById(
        'apparatus-with-multiple-subscriptions-mobile-platform' + this.fuelTank.apparatusId
      ).style.display = 'block'
    },
    openRemoveApparatusWithMultipleSubscriptionsMobilePlatformModal() {
      document.getElementById(
        'remove-apparatus-with-multiple-subscriptions-mobile-platform' + this.fuelTank.apparatusId
      ).style.display = 'block'
    },
    closeDealerModal() {
      document.getElementById('dealer-managed-sub-expired' + this.fuelTank.apparatusId).style.display = 'none'
    },
    closeUpgradeToPremiumModal() {
      document.getElementById('upgrade-to-premium-sub-expired' + this.fuelTank.apparatusId).style.display = 'none'
    },
    navToSupportPage() {
      this.$appInsights.trackEvent({
        name: 'click-contact-support-tank-card-subscription-issue-modal',
        properties: { apparatusId: this.fuelTank.apparatusId }
      })
      this.$router.push({
        path: `/support`
      })
    },
    /** Unused. */
    subscribeToPremium() {
      this.$appInsights.trackEvent({
        name: 'click-subscribe-to-premium-tank-card-subscription-issue-modal',
        properties: { apparatusId: this.fuelTank.apparatusId }
      })
      this.closeUpgradeToPremiumModal()
      this.openEnrollmentFlow()
    },
    // Adding this method for determining when we want to show "finish setup" instead of "your account needs attention".
    // If the user has never seen the subscription screen then they should be given the "finish setup" text and this method would return false.
    // Otherwise, they'll see "your account needs attention" and this method will return true.
    tankHadPreviousSubscription() {
      if (!this.fuelTank) return false

      const fmHasCancelledSubscription =
        this.fmSubscriptionDetails && this.fmSubscriptionDetails?.status === Constants.SubscriptionDetailCanceled

      const hasCancelledLegacySubscription =
        !this.fmSubscriptionDetails &&
        this.fmLegacySubscriptionDetails &&
        this.fmLegacySubscriptionDetails.status === Constants.SubscriptionCancelled

      return fmHasCancelledSubscription || hasCancelledLegacySubscription
    },
    tankHasSubscription() {
      if (!this.fuelTank) return false

      const isNotValidFuelTankType = this.fuelTank.type !== Constants.FuelTankApparatusType

      const fmHasNonCancelledSubscription =
        this.fmSubscriptionDetails && this.fmSubscriptionDetails?.status !== Constants.SubscriptionDetailCanceled

      const hasLegacySubscription =
        !this.fmSubscriptionDetails &&
        this.fmLegacySubscriptionDetails &&
        this.fmLegacySubscriptionDetails?.status !== Constants.SubscriptionCancelled

      const hasActiveSubscriptionWithValidStatus =
        this.subscription &&
        this.subscription.length >= 1 &&
        this.subscription[0].value.status &&
        [
          Constants.SubscriptionActive,
          Constants.SubscriptionPendingCancellation,
          Constants.SubscriptionPendingTermination,
          Constants.SubscriptionPendingSuspension,
          Constants.SubscriptionDunning
        ].includes(this.subscription[0].value.status)

      if (!this.tankHasAllProperties() || isNotValidFuelTankType) return false

      if (fmHasNonCancelledSubscription || hasLegacySubscription || hasActiveSubscriptionWithValidStatus) {
        return true
      }

      return false
    },
    tankHasAllProperties() {
      if (this.fuelType && this.orientation && this.capacity) {
        return true
      }
      return false
    },
    tankHasDealerAndActivePremiumSub() {
      if (!this.fuelTank) return false
      if (this.fuelTank.type != Constants.FuelTankApparatusType) {
        return false
      }

      if (
        this.fuelTank.isDealerManaged &&
        this.organizationSubscriptionDetails?.subscriptions?.filter(
          subscription =>
            subscription.apparatuses.some(apparatus => apparatus.apparatusId === this.fuelTank.apparatusId) &&
            subscription.status === Constants.SubscriptionDetailActive
        ).length > 1
      ) {
        return true
      }
      return false
    },
    openEnrollmentFlow() {
      if (!this.billingMaintenanceFeatureFlagEnabled(this.currentAppConfig)) {
        if (!this.tankHasAllProperties() && this.tankHasSubscription()) return
        if (!this.tankHasAllProperties()) {
          this.$emit('missingProperties', { deviceType: this.deviceType, apparatusId: this.fuelTank.apparatusId })
        } else if (!this.tankHasSubscription()) {
          if (
            this.deviceType == Constants.TankUtilityWifiDeviceType ||
            this.deviceType == Constants.TankUtilityLteDeviceTypeV1
          ) {
            this.subscribeFreeProduct()
          } else {
            this.$emit('noSubscription', { deviceType: this.deviceType, apparatusId: this.fuelTank.apparatusId })
          }
        }
      }
    },
    noSignalMessage() {
      if (this.deviceType == Constants.TankUtilityWifiDeviceType) {
        return this.$t('xNoWifiSignal')
      } else if (
        this.deviceType == Constants.TankUtilityLteDeviceTypeV1 ||
        this.deviceType == Constants.TankUtilityLteDeviceTypeV2
      ) {
        return this.$t('xNoCellularSignal')
      } else return this.$t('xDisconnected')
    },
    noSignalIcon() {
      if (!this.tankHasAllProperties() && this.tankHasSubscription()) return 'far fa-clipboard-list-check colorGray700'
      if (!this.enrollmentComplete() || !this.isConnected) {
        if (this.deviceType == Constants.TankUtilityWifiDeviceType) {
          return 'fas fa-wifi-slash statusIsDisconnected'
        } else if (
          this.deviceType == Constants.TankUtilityLteDeviceTypeV1 ||
          this.deviceType == Constants.TankUtilityLteDeviceTypeV2
        ) {
          return 'fas fa-signal-alt-slash statusIsDisconnected'
        }
      } else return 'fas fa-circle-check statusIsReady'
    },
    getStatusText() {
      if (!this.tankHasAllProperties() && this.tankHasSubscription()) return this.$t('xFinalizingSetup')
      if (!this.enrollmentComplete() || !this.isConnected) {
        return this.$t('xNoSignal')
      } else return this.$t('xConnected')
    },
    /** Unused. */
    getHeaderBGVariant() {
      if (!this.enrollmentComplete()) return 'statusWarning'
      else if (!this.isConnected) return 'statusDisconnected'
    },
    /** Unused. */
    getApparatusCardClass() {
      if (this.apparatus && this.enrollmentComplete()) {
        if (this.apparatusInfo.isConnecting) return ''
        else return this.apparatus.isConnected ? `apparatusCard${this.apparatus.apparatusStatus}` : ''
      }
    },
    getClass() {
      let result = ''
      if (this.tankHasSubscription() && !this.tankHasAllProperties()) {
        result = 'apparatus-card-nohover '
      } else {
        result = 'apparatus-card hoverPointer'
      }
      result += !this.subscribingWifiProduct && this.tankHasAllProperties() ? ' hoverPointer' : ''
      result += !this.isConnected ? ' ' : ''
      return result
    },
    enrollmentComplete() {
      return this.tankHasSubscription() && this.tankHasAllProperties()
    },
    /** For wifi Tanks and V1. */
    subscribeFreeProduct() {
      this.subscribingWifiProduct = true
      let productId = Constants.TankUtilityFreeProductId
      this.$store
        .dispatch('changeBillingAccountProduct', {
          organizationId: this.accountProfile.organizationId,
          apparatusId: this.fuelTank.apparatusId,
          productId: productId
        })
        .then(response => {
          this.subscribingWifiProduct = false
          document.getElementById('free-enrollment-success' + this.fuelTank.apparatusId).style.display = 'block'
          this.$store.dispatch('getApparatusesSilent')
        })
        .catch(error => {
          let failureMessage = this.$t('xFailedToSetTankSub')
          if (error?.response?.data?.message) {
            try {
              let messageAsJson = JSON.parse(error.response.data.message.replace(/\\"/g, '"'))
              if (messageAsJson?.gatewayResponse?.message) {
                failureMessage = messageAsJson?.gatewayResponse?.message
              }
            } catch (err) {}
          }
          this.subscribingWifiProduct = false
          this.$store.dispatch('displayToast', {
            title: this.$t('xError'),
            message: failureMessage,
            variant: 'danger'
          })
        })
    },
    /** Extract subscription data (legacy and/or modern) for this fuel monitor from the organization subscription information. */
    setSubscriptionDetails() {
      // Prefer the use of fmSubscriptionDetails over fmLegacySubscriptionDetails if fmSubscriptionDetails is defined.
      this.fmSubscriptionDetails = getSubscriptionForApparatus(
        this.fuelTank.apparatusId,
        this.organizationSubscriptionDetails?.subscriptions
      )
      this.fmLegacySubscriptionDetails = getLegacySubscriptionForApparatus(
        this.fuelTank.apparatusId,
        this.organizationSubscriptionDetails?.legacyBillingProducts
      )
    },
    tankDealerSubscriptionExpired() {
      if (!this.fuelTank) return false
      if (this.fuelTank.type != Constants.FuelTankApparatusType) {
        return true
      }

      if (!isFuelMonitorV2(this.fuelTank)) {
        return false
      }

      const tankDealerSub = this.organizationSubscriptionDetails?.subscriptions?.find(
        subscription =>
          subscription.store === Object.values(Constants.SubscriptionStoreTypes).indexOf('Dealer') &&
          subscription.apparatuses.find(apparatus => apparatus.apparatusId === this.fuelTank.apparatusId)
      )
      // If tank sub is cancelled and is a dealer based subscription.
      if (
        this.fuelTank?.isDealerManaged &&
        (!tankDealerSub || tankDealerSub?.status === Constants.SubscriptionDetailCanceled)
      ) {
        return true
      }

      // If there are no non-legacy subscriptions, turn to legacy billing info if available.
      if (!this.fmSubscriptionDetails && this.fmLegacySubscriptionDetails) {
        if (
          this.fuelTank &&
          this.fuelTank.isDealerManaged &&
          this.fmLegacySubscriptionDetails?.status === Constants.SubscriptionCancelled
        ) {
          return true
        }
      }

      return false
    },
    /** Unused. */
    fuelMonitorExpired() {
      if (!this.fuelTank) return false
      if (this.fuelTank.type != Constants.FuelTankApparatusType) {
        return true
      }
      if (!isFuelMonitorV2(this.fuelTank)) {
        return false
      }
      if (this.fuelTank.isDealerManaged) return false
      if (this.fmSubscriptionDetails && this.fmSubscriptionDetails.status === Constants.SubscriptionDetailCanceled) {
        return true
      }
      // If there are no non-legacy subscriptions, turn to legacy billing info if available.
      if (!this.fmSubscriptionDetails && this.fmLegacySubscriptionDetails) {
        if (this.fmLegacySubscriptionDetails.status === Constants.SubscriptionCancelled) {
          return true
        }
      }

      if (!this.fuelTank.properties) return false

      return false
    },
    isSubscriptionGracePeriod() {
      if (!this.fuelTank) return false
      if (this.fuelTank.type != Constants.FuelTankApparatusType) {
        return true
      }
      if (!isFuelMonitorV2(this.fuelTank)) {
        return false
      }

      // check modern subscriptions for grace period status
      if (
        this.fmSubscriptionDetails &&
        this.fmSubscriptionDetails.reason === Constants.SubscriptionDetailsReasonGracePeriodStarted
      ) {
        return true
      }

      // check legacy subs (if applicable) for dunning status (same as grace period)
      if (!this.fmSubscriptionDetails && this.fmLegacySubscriptionDetails) {
        if (
          this.fmLegacySubscriptionDetails.status === Constants.SubscriptionDunning ||
          this.fmLegacySubscriptionDetails?.dunningState === Constants.DunningInProgress
        ) {
          return true
        }
      }

      return false
    },
    /** Returns whether or not the account has a mobile subscription that is active/pending cancel/pending change. This subscription may or may not include this fuel monitor. */
    accountHasActiveMobileSubscription() {
      const activeSubs = this.organizationSubscriptionDetails?.subscriptions?.filter(sub =>
        subscriptionDetailActive(sub.status)
      )

      if (!activeSubs?.length) {
        return false
      }

      return activeSubs.some(activeSub => {
        if (
          activeSub.store === Constants.AppleSubscriptionStore ||
          activeSub.store === Constants.GoogleSubscriptionStore
        ) {
          this.mobileSubscriptionStore = activeSub.store
          this.activeMobileSubscription = activeSub
          return true
        }

        return false
      })
    },
    hasPendingProductChange() {
      return this.organizationSubscriptionDetails?.subscriptions?.some(
        subscription => subscription.status === Constants.SubscriptionDetailPendingProductChange
      )
    },
    hasPendingCancelPlan() {
      const iapPendingCancelSubscription = this.organizationSubscriptionDetails?.subscriptions?.find(
        subscription => subscription.status === Constants.SubscriptionDetailPendingCancel
      )
      const legacyPendingCancelSubscription = this.organizationSubscriptionDetails?.legacyBillingProducts?.products?.find(
        product => product.status === Constants.SubscriptionPendingCancellation
      )
      if (iapPendingCancelSubscription) this.pendingCancelRenewalDate = iapPendingCancelSubscription.renewalDate
      else if (legacyPendingCancelSubscription)
        this.pendingCancelRenewalDate = legacyPendingCancelSubscription.nextBillingDate
      return iapPendingCancelSubscription || legacyPendingCancelSubscription
    },
    openPlanPendingChangeModal() {
      this.openModal(`pending-plan-change-modal-${this.fuelTank.apparatusId}`)
    },
    openPlanPendingCancelModal() {
      this.openModal(`pending-plan-cancel-modal-${this.fuelTank.apparatusId}`)
    }
  },
  mounted() {
    if (!this.currentAppConfig) this.$store.dispatch('getApplicationConfiguration', 'Any')
    if (this.apparatusInfo) {
      this.fuelTank = this.apparatusInfo
      this.isConnected = this.fuelTank ? this.fuelTank.isConnected : false
      if (this.fuelTank.properties) {
        if (this.fuelTank.properties.find(x => x.name == 'LastReading')?.value) {
          this.lastReadingDate = this.fuelTank.properties.find(x => x.name == 'LastReading').value
        }
        if (this.fuelTank.properties.find(x => x.name == 'FuelType')?.value) {
          this.fuelType = this.fuelTank.properties.find(x => x.name == 'FuelType').value
        }
        if (this.fuelTank.properties.find(x => x.name == 'Orientation')?.value) {
          this.orientation = this.fuelTank.properties.find(x => x.name == 'Orientation').value
        }
        if (parseInt(this.fuelTank.properties.find(x => x.name == 'Capacity')?.value)) {
          this.capacity = parseInt(this.fuelTank.properties.find(x => x.name == 'Capacity').value)
        }
        if (this.fuelTank.properties.find(x => x.name == 'ConsumptionTypes')?.value) {
          this.consumptionTypes = this.fuelTank.properties.find(x => x.name == 'ConsumptionTypes').value
        }
        if (this.fuelTank.properties.find(x => x.name == 'FuelDealerId')?.value) {
          this.fuelDealerId = this.fuelTank.properties.find(x => x.name == 'FuelDealerId').value
        }
        if (parseInt(this.fuelTank.properties.find(x => x.name == 'FuelLevel')?.value)) {
          this.fuelLevel = parseInt(this.fuelTank.properties.find(x => x.name == 'FuelLevel').value)
        }
        this.subscription = this.fuelTank.properties.filter(x => x.type == Constants.ApparatusPropertySubscription)
        this.device = this.fuelTank.properties.filter(x => x.type == Constants.ApparatusPropertyDevice)
        if (this.device && this.device[0] && this.device[0].value) {
          this.batteryLevel = this.device[0].value.batteryLevel ? this.device[0].value.batteryLevel : 'critical'
          this.deviceType = this.device[0].value.deviceType ? this.device[0].value.deviceType : null
        }

        // open enrollment flow deep link
        const matchesEnrollRouteParams =
          this.$route.params.apparatusId == this.apparatusInfo.apparatusId &&
          this.$route.params.apparatusType == this.apparatusInfo.type
        if (matchesEnrollRouteParams && !this.enrollmentComplete()) {
          this.openEnrollmentFlow()
        } else if (matchesEnrollRouteParams && this.enrollmentComplete()) {
          this.$router.push({
            path: `/dashboard`
          })
        }
      }
    }
    if (this.organizationSubscriptionDetailsData) {
      this.organizationSubscriptionDetails = this.organizationSubscriptionDetailsData
      this.setSubscriptionDetails()
    }

    if (this.organizationSubscriptionDetails?.subscriptions?.length > 0) {
      // Filter by active, non Dealer Managed subscriptions
      const activeSubs = this.organizationSubscriptionDetails?.subscriptions?.filter(
        subs => subs.status !== Constants.SubscriptionDetailCanceled && subs.store !== Constants.DealerSubscriptionStore
      )
      // Check if there is an active sub that was bought through WEB
      if (activeSubs && activeSubs.some(sub => sub.store === Constants.WebSubscriptionStore)) {
        // The sub is from WEB
        this.subscriptionStoreIsWebOrLegacy = true
      } else {
        // The sub is from APPLE or GOOGLE
        this.subscriptionStoreIsWebOrLegacy = false
      }
    }
    if (this.organizationSubscriptionDetails?.legacyBillingProducts?.products?.length > 0) {
      // Filter by active, non Dealer Managed subscriptions
      const activeSubs = this.organizationSubscriptionDetails?.legacyBillingProducts?.products?.filter(
        subs => subs.status !== Constants.SubscriptionCancelled
      )
      // Check if there is an active sub that was bought through WEB
      if (activeSubs?.length > 0) {
        // The sub is from WEB
        this.subscriptionStoreIsWebOrLegacy = true
      }
    }
  }
}
</script>

<style>
.tankImage {
  max-height: 100px;
}

.batteryGood {
  color: var(--green-500) !important;
}

.batteryWarning {
  color: var(--yellow900) !important;
}

.batteryCritical {
  color: var(--red-500) !important;
}

.tu-row-2 {
  padding-top: 35px;
}

.colorGray700 {
  color: var(--carbon-600) !important;
}
</style>
